import { render } from "./list_new.vue?vue&type=template&id=ac96b820"
import script from "./list_new.js?vue&type=script&lang=js"
export * from "./list_new.js?vue&type=script&lang=js"

import "./list_new.vue?vue&type=style&index=0&id=ac96b820&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__